/**
 * Icône AthleOS — figure en A stylisée extraite du SVG d'origine.
 * Seuls les 2 paths de l'icône sont rendus (pas le rectangle, pas le wordmark).
 * fill = couleur de l'icône (accent du coach).
 */
const ICON_PATHS = [
  "M80.07 322.76 c-4.78 -1.52 -8.36 -5.19 -9.83 -10.06 -1.47 -4.73 -1.10 -6.29 3.58 -16.31 4.46 -9.51 5.93 -11.44 10.29 -13.55 1.33 -0.69 9 -3.08 16.95 -5.33 7.95 -2.25 23.98 -6.80 35.60 -10.11 11.62 -3.26 28.07 -7.95 36.52 -10.34 8.45 -2.39 23.15 -6.52 32.62 -9.23 9.97 -2.80 18.60 -5.51 20.44 -6.43 9.97 -4.78 15.71 -16.58 12.82 -26.46 -0.74 -2.57 -5.83 -12.68 -28.21 -56.23 -21.96 -42.77 -30.14 -58.75 -30.73 -60.27 -0.32 -0.83 -0.60 -2.53 -0.60 -3.77 0 -2.11 0.96 -4.13 10.66 -23.01 6.48 -12.49 11.39 -21.45 12.40 -22.65 5.74 -6.52 18.10 -7.76 25.86 -2.62 2.89 1.93 4.64 4.50 8.82 12.86 1.98 3.90 8.31 16.31 14.10 27.56 5.83 11.25 14.33 27.79 18.97 36.75 4.64 8.96 13.51 26.23 19.75 38.36 49.70 96.38 72.58 141.17 73.27 143.28 0.78 2.39 0.28 6.71 -1.10 9.69 -1.47 3.26 -4 5.93 -6.89 7.35 l-2.39 1.19 -27.10 -0.14 c-26.60 -0.14 -27.10 -0.14 -29.22 -1.15 -4 -1.84 -5.05 -3.45 -14.38 -21.96 -7.26 -14.42 -9.14 -17.78 -11.16 -20.03 -2.76 -2.99 -6.48 -5.10 -10.47 -5.93 -1.79 -0.37 -14.19 -0.51 -44.42 -0.37 l-41.90 0.18 -2.99 1.06 c-3.63 1.33 -8.77 4.64 -10.29 6.61 -0.64 0.83 -4.87 8.91 -9.46 18.01 -4.59 9.10 -9.19 17.59 -10.20 18.93 -1.19 1.56 -2.66 2.80 -4.18 3.58 l-2.34 1.15 -26.41 -0.05 c-20.40 0 -26.92 -0.14 -28.39 -0.60z",
  "M116.08 239.52 c-3.17 -0.96 -6.02 -3.90 -6.71 -6.94 -0.96 -3.95 -1.75 -2.20 17.64 -39.41 7.90 -15.16 19.84 -38.31 28.71 -55.58 2.57 -5.05 5.10 -9.65 5.65 -10.20 1.29 -1.42 3.72 -1.84 5.60 -0.92 1.06 0.51 1.84 1.42 2.66 3.17 10.70 22.83 19.11 41.67 22 49.24 3.17 8.36 4.09 12.13 4.36 17.96 0.32 6.34 -0.78 11.39 -3.81 17.64 -1.70 3.54 -2.80 4.96 -5.83 8.09 -6.98 6.98 -11.35 8.68 -31.56 12.45 -30.82 5.65 -33.81 6.02 -38.73 4.50z",
];

export default function AthleosLogoSvg({ fill = "#B8FF47", width, height, style, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="49 16 335 335"
      width={width}
      height={height}
      preserveAspectRatio="xMidYMid meet"
      style={style}
      className={className}
    >
      <g fill={fill}>
        {ICON_PATHS.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </g>
    </svg>
  );
}
